import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import router from './router';

Vue.use(Vuex)

export default new Vuex.Store({
	plugins:[createPersistedState()],
  	state: {
    	status: '',
    	api_key: null,
		user :  {},
		login_expire: null
  	},
  	getters : {
    	isLoggedIn: state => !!state.api_key,
    	authStatus: state => state.status,
		username: state => state.user.username,
		getUser: state => state.user,
		getApiKey: state => state.api_key,
		isAdmin: state => state.user.id_role === 2,
		loginExpire: state => state.login_expire
  	},
  	mutations: {
    	AUTH_SUCCESS(state,data){
			state.status = 'success';
			state.api_key = data.api_key;
			state.user = data.user;
			state.login_expire = Vue.prototype.$moment().add(120,'m').format('YYYY-MM-DD HH:mm:ss');
    	},
    	/*auth_error(state){
     		state.status = 'error'
    	},*/
    	LOGOUT(state){
      		state.status = ''
      		state.api_key = null,
			state.user = {},
			state.login_expire = null
    	},
  	},
  	actions: {
		async login({commit}, user){
			let result = await Vue.prototype.$api.post('user/login',user);
			Vue.prototype.$api.defaults.headers.common['Authorization'] = 'Bearer '+result.data.api_key;
			/*let api_key = result.data.api_key;
			let login_user = result.data.user;*/
			//debugger;
			//API.test();
			//debugger;
			//localStorage.setItem('api_key',api_key);
			//localStorage.setItem('user', JSON.stringify(login_user));
			
			commit('AUTH_SUCCESS',result.data);
			//API.setAuthorization(api_key)
			//Vue.prototype.$api.Authorization = 'Bearer '+state.api_key
			
		},
		async logout({commit}){
			await Vue.prototype.$api.post('user/logout');
			delete Vue.prototype.$api.defaults.headers.common.Authorization;
			commit('LOGOUT');
			router.push('/login');
			//window.location.href = '/login'
			
			/*return new Promise((resolve, reject) => {
			delete Vue.prototype.$api.defaults.headers.common.Authorization;
			commit('LOGOUT');*/
			//localStorage.removeItem('api_key');
			//localStorage.removeItem('user');
			//delete axios.defaults.headers.common['Authorization']
			/*resolve()
			})*/
		}
  	}
})